import { useCallback } from "react"
import { useQueryClient } from "react-query"

export interface ResetAllQueries {
  (): void
}

export interface IResetQuery {
  resetAllQueries: ResetAllQueries
}

export const useResetQuery = (): IResetQuery => {
  const queryClient = useQueryClient()

  const resetAllQueries = useCallback(() => {
    queryClient.clear()
    queryClient.invalidateQueries()
  }, [queryClient])

  return {
    resetAllQueries
  }
}

export default useResetQuery
